import React, { Component } from 'react'
import Panel from '@common/Panel'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Calendar, Badge, Spin } from 'hljd'
import {
  PRIVILEGE_STORE_ID,
  PRIVILEGE_STORE_SERVICE_ID,
  JIAMENG_SCHEDULE
} from '@constant'
import { Link } from 'react-router'
import { Auth } from '@common/Auth'
import { observer } from 'mobx-react'
import Store from './store'
import style from './style.module.less'
import moment from 'moment'

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getCalendarTask()
  }

  dateCellRender = (value, calendarTasks) => {
    const data = this.getListData(value, calendarTasks)
    return data ? data : null
  }

  getListData = (value, calendarTasks) => {
    const date = moment(value).format(__FMT1__)
    const dateTask = calendarTasks[date]
    return dateTask && dateTask.count > 0 ? <Badge dot /> : null
  }

  render() {
    const {
      currentDate,
      onSelect,
      prevMonth,
      nextMonth,
      loading,
      calendarTasks
    } = this.store

    return (
      <Panel
        title="日程"
        action={<Link to={JIAMENG_SCHEDULE}>查看全部</Link>}
        contentStyle={{ padding: 0 }}
      >
        <div className={style.calendar}>
          <div className={style.header}>
            <LeftOutlined onClick={prevMonth} className={style.prev} />
            <span>{currentDate && currentDate.format('YYYY年MM月')}</span>
            <RightOutlined onClick={nextMonth} className={style.next} />
          </div>

          <Spin spinning={loading}>
            <Calendar
              fullscreen={false}
              onSelect={onSelect}
              value={currentDate}
              dateCellRender={value =>
                this.dateCellRender(value, calendarTasks)
              }
            />
          </Spin>
        </div>
      </Panel>
    )
  }
}
